import {Tenant} from "./tenant";
import {Organization} from "./organization";

export class ApplicationNotification {
  uuid: string;
  name: string;
  topic: string;
  notificationType: any;
  tenant: Tenant;
  organization: Organization;
  template: string;
  subject: string;
  emails: string[];
  tenantUuid: string;
}
